<template>
  <div v-if="error" class="text-center fixed-[0] overflow-hidden text-white">
    <div class="m-8 relative top-[30%] -translate-y-[50%]">
      <h1 class="text-18 font-bold">{{ $t('ErrorBoundary.Error') }}</h1>
      <p class="text-15 mt-5">{{ $t('ErrorBoundary.SomethingWentWrong') }}</p>
      <van-button class="primaryBtn !mt-10" @click="retry">{{ $t('ErrorBoundary.Retry') }}</van-button>
    </div>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { useErrorBoundary } from '@/hooks/useErrorBoundary'

const { error, captureError } = useErrorBoundary()

const retry = () => {
  location.reload()
}

onErrorCaptured((err, instance, info) => {
  captureError(err, instance, info)
})
</script>
